import { useQuery } from "@tanstack/react-query";
import { fetchAiAudioAnnotationsForJobApi } from "../job.services";
import { RAMSALAB_ORG } from "../../constants/constants";

export const AI_AUDIO_ANNOTATIONS_KEY = "ai-audio-annotations";

export const useAiAudioAnnotationsForJob = ({ queryConfig }) => {
  const { queryKey, apiParams, ...restConfig } = queryConfig;
  const OrgSlug = localStorage.getItem(RAMSALAB_ORG);
  apiParams.org = OrgSlug;

  return useQuery({
    queryKey: [AI_AUDIO_ANNOTATIONS_KEY, ...queryKey],
    queryFn: () =>
      fetchAiAudioAnnotationsForJobApi({
        ...apiParams,
      }),
    refetchOnWindowFocus: false,
    ...restConfig,
  });
};
